import { render, staticRenderFns } from "./UserCreateRolesPermissionsTab.vue?vue&type=template&id=db0b6a20"
import script from "./UserCreateRolesPermissionsTab.vue?vue&type=script&lang=ts"
export * from "./UserCreateRolesPermissionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports